<div *ngIf="type" [innerHTML]="termsAndConditions" data-auto-id="terms-and-conditions-for-payment"></div>
